import { Directive, HostBinding, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[formControlName],[formControl]',
    exportAs: 'autoValidation',
    standalone: false
})
export class AutoValidationDirective {
  constructor(@Self() private ngControl: NgControl) {}

  @HostBinding('class.is-invalid')
  get isInvalid(): boolean {
    const control = this.ngControl.control;
    return control ? control.invalid && control.touched : false;
  }

  @HostBinding('class.is-valid')
  get isValid(): boolean {
    const control = this.ngControl.control;
    return control ? control.valid && control.touched : false;
  }
}
